import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { Subject } from 'rxjs';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SlideToggleComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SlideToggleComponent
    }
  ]
})
export class SlideToggleComponent implements OnInit, ControlValueAccessor {

  @Input() label: string | null = null;

  @Input() color: ThemePalette;

  @Input() disableRipple: boolean = false;

  @Input() labelPosition: 'before' | 'after' = 'before';

  @Output() valueChanged = new Subject<boolean>();

  // Control Value Accessor
  touched = false;
  disabled = false;
  validationStatus: ValidationErrors | null;
  value: boolean;

  constructor() { }

  ngOnInit(): void { }

  onChange: Function = Function;

  onTouched = () => { };

  /**
   * Writes value
   * @param value
   */
  writeValue(value: boolean) {
    this.value = value;
  }

  /**
   * Registers on change
   * @param onChange
   */
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  /**
   * Registers on touched
   * @param onTouched
   */
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  /**
   * Marks as touched
   */
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  /**
   * Sets disabled state
   * @param disabled
   */
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  /**
   * Validates date time range component
   * @param control
   * @returns validate
   */
  validate(control: AbstractControl): ValidationErrors | null {
    this.validationStatus = null;
    return this.validationStatus;
  }

  /**
   * Determines whether toggle change on
   * @param value
   */
  onValueChange(event: MatSlideToggleChange) {
    this.valueChanged.next(event?.checked);
    this.value = event?.checked;
    this.onChange(this.value);
  }
}
